import { render, staticRenderFns } from "./SfInput.vue?vue&type=template&id=4bedd77c&"
import script from "./SfInput.vue?vue&type=script&lang=js&"
export * from "./SfInput.vue?vue&type=script&lang=js&"
import style0 from "./SfInput.vue?vue&type=style&index=0&id=4bedd77c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports